/**
 * PaperScroller `centerContent` analogue for the EDG/FSM zoom toolbar.
 *
 * Pans so the content bounding-box centre sits in the pane centre and leaves
 * zoom unchanged. This is not React Flow `fitView()` (`zoomToFit`): that scales
 * the diagram to fill the pane.
 *
 * `setCenter(x, y)` must be given the current zoom. xyflow treats an omitted
 * zoom as `maxZoom`, which would jump the view to 400%.
 */
export type ContentBounds = {
  x: number;
  y: number;
  width: number;
  height: number;
};

export type CenterContentFlow = {
  getNodes: () => ReadonlyArray<{ id: string }>;
  getNodesBounds: () => ContentBounds;
  getZoom: () => number;
  setCenter: (x: number, y: number, options?: { zoom?: number }) => void;
};

export function centerContent(flow: CenterContentFlow): void {
  if (flow.getNodes().length === 0) return;

  const bounds = flow.getNodesBounds();
  flow.setCenter(bounds.x + bounds.width / 2, bounds.y + bounds.height / 2, {
    zoom: flow.getZoom(),
  });
}
